import { makeStyles, withStyles } from '@material-ui/core/styles'

import LinearProgress from '@material-ui/core/LinearProgress'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  progressBarWrap: {
    height: 'auto',
    position: 'absolute',
    bottom: 32,
    right: 32,
    zIndex: 100,
    width: '100%',
    maxWidth: 438,

    [useBreakpoints(theme).lessThan.sm]: {
      left: 0,
      right: 0,
      bottom: 15,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  progressBar: {
    backgroundColor: themesConfig.default.colors.white,
    boxShadow: `0px 4px 14px 0px ${themesConfig.default.palette.grey.light}`,
    width: '100%',
    borderRadius: 8,
    padding: '16px 20px',
  },

  prograssTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    color: themesConfig.default.colors.black,
  },

  progressIndicatorWrap: {
    height: 'auto',
    marginTop: 12,
    border: `1px solid ${themesConfig.default.colors.lavender}`,
    padding: '7px 14px',
    borderRadius: 8,
  },

  closeIcon: {
    color: themesConfig.default.colors['red-500'],
  },
}))

export const CustomLinearProgress = withStyles(() => ({
  root: {
    height: 4,
    borderRadius: 5,
  },
  colorSecondary: {
    backgroundColor: themesConfig.default.colors.lavender,
  },
  bar: {
    borderRadius: 5,
  },
  barColorPrimary: {
    backgroundColor: themesConfig.default.colors['green-500'],
  },
  barColorSecondary: {
    backgroundColor: themesConfig.default.colors.secondary,
  },
}))(LinearProgress)
